import { updateInventoryTransaction } from "../../api/inventoryService";

export const useUpdateInventoryTransaction = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateInventoryTransaction(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update inventory transaction:", error);
        throw error;
    }
  };

  return { update };
};